import { TextAlign } from 'src/shared/Constants';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled, { css } from 'styled-components';
import { Colors, Font, ScreenWidth } from 'web-common/src/shared/styles';

export const DesktopSearchWrapper = styled.div<{ isV2Styling?: boolean }>`
  ${ifProp(
    'isV2Styling',
    css`
      ${minScreen(ScreenWidth.MEDIUM)} {
        flex-grow: 1;
        max-width: 390px;
      }
    `
  )}

  .search-container {
    position: relative;
    font-family: ${Font.Family.SANS};
    font-weight: 400;
    height: 40px;
    width: 400px;

    ${ifProp(
      'isV2Styling',
      css`
        ${minScreen(ScreenWidth.MEDIUM)} {
          width: 100%;
        }
      `,
      css`
        @media screen and (max-width: ${ScreenWidth.MEDIUM}) {
          width: 290px;
        }

        @media screen and (min-width: ${ScreenWidth.EXTRA_LARGE}) {
          width: 500px;
        }
      `
    )}
  }

  .search-sub-container {
  }

  .input-container {
    display: flex;
    align-items: center;
    height: 100%;
    border: 1px solid ${Colors.GRAY_LITE_10};
    border-radius: 5px;
    :focus {
      border-bottom-left-radius: '0px';
      border-bottom-right-radius: '0px';
    }
  }
  .input-sub-container {
  }
  .back-button {
  }
  .clear-button {
  }

  // TO DO
  .search-icon {
    font-size: 14px;
    margin: 0px 10px;
    cursor: pointer;
  }

  .search-box-wrapper {
    width: 100%;
    height: 100%;
  }

  .searchbox-input {
    border: none;
    border-radius: 5px;
    width: 100%;
    height: 100%;
    outline: none;

    color: ${Colors.BLACK};
    font-family: ${Font.Family.SANS};
    font-size: 14px;
    font-weight: 500;
    text-align: ${TextAlign.LEFT};
    padding: 0px;
    padding-top: 2px;

    ::placeholder {
      color: ${Colors.GRAY_DARK_10};
    }

    ${ifProp(
      'isV2Styling',
      css`
        font-family: ${Font.Family.BODY_SANS};
      `
    )}
  }

  .searchbox-wrapper {
    height: 100%;

    .searchbox-form {
      height: 100%;

      .searchbox-input {
        height: 100%;
      }
    }
  }

  .results-container-wrapper {
    position: absolute;
    background: ${Colors.WHITE};
    top: 40px;
    right: 0px;
    border-radius: 0px;
    border: 1px solid ${Colors.GRAY_LITE_10};
    border-top: none;
    box-shadow: 15px 15px 30px 5px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-height: 90vh;
    overflow: auto;
  }

  .results-container {
    padding: 20px 25px;
  }

  .result-section-header {
    font-size: 22px !important;
    line-height: normal;
    margin: 0 0 10px;

    :first-child {
      margin-top: 0;
    }
  }

  .result-item {
    display: flex;
    flex-flow: row;
    align-items: center;
    padding: 5px 0px;
  }

  .styled-result-link-container {
  }

  .styled-result-link {
    display: block;
    margin: 0;
    margin: 0 -25px !important;
    padding: 0px 25px;

    &.gift-card-result-link {
      margin-bottom: 10px !important;
    }

    @media screen and (max-width: ${ScreenWidth.MEDIUM}) {
      padding: 0px 15px;
    }

    :hover {
      background-color: ${Colors.GRAY_LITE_30};
    }
  }

  .result-text-container {
  }

  .result-image-container {
    display: table-cell;
    vertical-align: top;
    margin-right: 20px;
    height: 72px;
    flex: 0 0 88px;
    position: relative;
    overflow: hidden;
  }

  .result-image {
    position: absolute;
    max-width: 100%;
    height: 100%;
    width: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.shef-result-image {
      border-radius: 36px;
    }
  }

  .result-title {
    color: ${Colors.GRAY_DARK_30};
    font-family: ${Font.Family.SANS};
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    text-align: left;
  }

  .result-subtitle {
    color: ${Colors.GRAY};
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
  }

  .result-not-found-container {
    padding: 30px;
  }

  .result-not-found-title {
    color: ${Colors.GRAY_DARK_30};
    font-family: ${Font.Family.SANS};
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    text-align: left;
  }

  .result-not-found-message {
    color: ${Colors.GRAY};
    font-family: ${Font.Family.SANS};
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
  }
`;
